import { ICommInterface } from '../types/comm-interface';

export class Livechat1 implements ICommInterface {
  Open = (): void => {};
  Start = (custInfo: any, []): void => {};
  setCaptcha = (elementIdRef: any): void => {};
  resetCaptcha = (elementIdRef: any): void => {};
  accessToken = (): void => {};
  receivedChatbotMsg = (msg?: any): void => {};
  End = (reason?: string, interactionID?: any): void => {};
  SendMessage = (msg?: any, command?: any, data?: any, interactionID?: any): void => {};
  checkDeviceSupport = (): void => {};
  callbackEvents = (): void => {};
  uploadFiles = (data: any): void => {};
  downloadUrl = (filename: any): void => {};
  uploadComplete = (): void => {};
  setAVConfigs = (Config: any): void => {};
  pauseAV = (audio: any, video: any): void => {};
  startAV = (startConfig: any): void => {};
  endAV = (): void => {};
  startScreenshare = (startConfig: any): void => {};
  stopScreenshare = (): void => {};
  notifyTypingChange = (state: any): void => {};
  holdAV = (): void => {};
}
